import { Divider } from '@mui/material'

import { Company } from './fields/Company'
import { EligibilityAndReccurrence } from './fields/EligibilityAndReccurrence'
import { Loads } from './fields/Loads'
import { Name } from './fields/Name'
import { OrderType } from './fields/OrderType'
import { Priority } from './fields/Priority'
import { Vehicle } from './fields/Vehicle'

import { Props } from './typings'

export function Order(props: Props) {
  return (
    <>
      <Name />

      <Company />

      <Divider />

      <EligibilityAndReccurrence {...props} />

      <Divider />

      <Loads {...props} />

      <Vehicle {...props} />

      <Divider />

      <Priority />

      <Divider />

      <OrderType {...props} />

      <Divider />
    </>
  )
}
